const tutorialList = () => import('@/pages/content/tutorial/index.vue');
const tutorialForm = () => import('@/pages/content/tutorial/form.vue');

export default [{
    path: '/content/tutorial',
    component: tutorialList,
    meta: [{
        name: '内容管理'
    },
    {
        name: '教学视频',
        activeRoute: '/content/tutorial'
    }]
}, {
    path: '/content/tutorial/form',
    component: tutorialForm,
    meta: [{
        name: '内容管理'
    }, {
        name: '教学视频',
        url: '/content/tutorial'
    }, {
        name: '新增/编辑',
        activeRoute: '/content/tutorial'
    }]
}];